/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { StaticDomainConfiguration } from 'src/components/ZillowNavbar/page-frame-types/StaticDomainConfiguration';
import { ZillowSVGImage } from '../../common/ZillowSVGImage/ZillowSVGImage';

const SizedZillowSVGImage = styled(ZillowSVGImage)`
    width: 120px;
    height: 25px;
    display: block;
`;
export type WhiteZillowLogoProps = {
    staticDomain: StaticDomainConfiguration;
};
export const WhiteZillowLogo: FunctionComponent<WhiteZillowLogoProps> = ({ staticDomain, ...rest }) => (
    <SizedZillowSVGImage {...rest} svgFileName="z-logo-white" svgName="Zillow logo" staticDomain={staticDomain} />
);
